import { render } from "./CardBox3.vue?vue&type=template&id=1612ec91&scoped=true"
import script from "./CardBox3.vue?vue&type=script&lang=js"
export * from "./CardBox3.vue?vue&type=script&lang=js"

import "./CardBox3.vue?vue&type=style&index=0&id=1612ec91&lang=scss&scoped=true"
import "./CardBox3.vue?vue&type=style&index=1&id=1612ec91&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1612ec91"]])

export default __exports__